import { type } from "arktype";
import { Adaptation, BlockKind, MovementPattern } from "./vocabulary";

export const KnowledgeSource = type({
  id: "string",
  title: "string",
  "authors?": "string",
  "url?": "string",
  evidenceGrade: "'A' | 'B' | 'C' | 'D'",
  license: "string",
  claims: "string[]",
  approvedForRationale: "boolean",
  "framework?": "string",
});
export type KnowledgeSource = typeof KnowledgeSource.infer;

export const Method = type({
  id: "string",
  name: "string",
  intent: "string",
  structure: "string",
  whenItFits: "string",
  attribution: "string",
  license: "string",
  "genericDescription?": "boolean",
  offeredByStaleness: "boolean",
  qualities: Adaptation.array(),
  template: type({ kind: BlockKind, exercises: type({ exerciseText: "string", pattern: MovementPattern, "sets?": "number", "reps?": "number", "timeSeconds?": "number", "rounds?": "number" }).array() }).array(),
  version: "number",
  retired: "boolean",
});
export type Method = typeof Method.infer;

export const RedFlagRule = type({ id: "string", pattern: "string", keywords: "string[]", advice: "string" });
export type RedFlagRule = typeof RedFlagRule.infer;
